import React from 'react';
import classNames from 'classnames';
import MessageCircleIcon from '../../../../assets/icons0/message-circle-01.svg';

const CommentButton = React.memo(({postId, commentsCount, onClick, isAuthorized, isCommented, isActive}) => {
    return (
        <button
            type='button'
            onClick={onClick}
            className={classNames(
                'display-flex align-items-center column-gap-0dot5rem background-color-transparent border-style-none padding-0 cursor-pointer padding-bottom-0dot25rem border-bottom-style-solid border-bottom-width-0dot125rem border-bottom-color-transparent',
                {
                    'border-bottom-color-gray-400': isActive
                }
            )}
        >
            <MessageCircleIcon className={classNames('display-block width-1dot25rem height-1dot25rem', {
                'color-blue-gray-500': isCommented,
                'color-gray-400': !isCommented,
                'hover-color-blue-gray-700': isAuthorized && !isCommented
            })} />
            <span className={classNames('text-sm', {
                'color-blue-gray-500 semibold': isCommented,
                'color-gray-500': !isCommented
            })}>
                {commentsCount || 0}
            </span>
        </button>
    );
});

export default CommentButton;

